import { render, staticRenderFns } from "./AITSTestReports.vue?vue&type=template&id=7f904ac2&"
import script from "./AITSTestReports.vue?vue&type=script&lang=js&"
export * from "./AITSTestReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports